const timeframes = {
  getTimeframeName(id) {
    switch (id) {
      case this.$enums.timeframes.LAST_6_MONTHS:
        return "Last 6 Months";
      case this.$enums.timeframes.LAST_12_MONTHS:
        return "Last 12 Months";
      case this.$enums.timeframes.ALL_TIME:
        return "All Time";
      case this.$enums.timeframes.CUSTOM:
        return "Custom Date Range";
      case this.$enums.timeframes.LAST_30_DAYS:
        return "Last 30 Days";
    }
    return "Last 90 Days";
  },
  getTimeframeMonths(id) {
    switch (id) {
      case this.$enums.timeframes.LAST_30_DAYS:
        return 1;
      case this.$enums.timeframes.LAST_90_DAYS:
        return 3;
      case this.$enums.timeframes.LAST_6_MONTHS:
        return 6;
      case this.$enums.timeframes.LAST_12_MONTHS:
        return 12;
      default:
        return 0;
    }
  }
};

export default { methods: timeframes };
